import { render, staticRenderFns } from "./WorkIconUnlink.vue?vue&type=template&id=cf4a7586"
import script from "./WorkIconUnlink.vue?vue&type=script&lang=js"
export * from "./WorkIconUnlink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports